import { useEffect } from "react";
import { useRedirect } from "react-admin";
import { useDispatch } from "react-redux";

import firebase from "../init/firebase";
import { logout } from "../redux/reducers/user";
import { DocReference } from "../types/firebase.types";
import { GenericObject } from "../types/generic.types";
import { AppResource } from "../types/resource.types";
import useCurrentUser from "./useCurrentUser";

const useKickUserOff = (query: DocReference, shouldLogout: (data: GenericObject) => boolean, canTrigger = false) => {
  const { user } = useCurrentUser();
  const dispatch = useDispatch();
  const redirect = useRedirect();

  useEffect(() => {
    let unsubscribeToUser: any;
    if (user.id && canTrigger) {
      unsubscribeToUser = query.onSnapshot({
        next(snapshot) {
          if (snapshot.exists) {
            const data = snapshot.data();
            if (data && shouldLogout(data)) {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  dispatch(logout());
                  redirect(`/${AppResource.login}`);
                })
                .catch((ex) => {
                  console.log(ex.message);
                });
            }
          }
        },
        error(ex) {
          console.log(ex.message);
        },
      });
    }

    return () => {
      if (unsubscribeToUser) unsubscribeToUser();
    };
  }, [user.id, query, canTrigger, shouldLogout]);
};

export default useKickUserOff;
